import { Trash2, GripVertical, Hash } from 'lucide-react'

/**
 * QuestionEditor Component
 * Edits a single question within a theme
 */
function QuestionEditor({ question, index, themeIndex, onUpdate, onDelete, isFirst, isLast }) {
  const handleChange = (field, value) => {
    onUpdate({ ...question, [field]: value })
  }

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
      <div className="flex items-start space-x-3">
        {/* Drag handle (visual only for now) */}
        <div className="flex-shrink-0 pt-2 text-gray-400 cursor-move">
          <GripVertical className="w-5 h-5" />
        </div>

        {/* Question fields */}
        <div className="flex-1 space-y-3">
          {/* Question ID (Auto-generated, read-only) */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center">
              <Hash className="w-4 h-4 mr-1" />
              ID de la question (auto-généré)
            </label>
            <div className="flex items-center space-x-2">
              <input
                type="text"
                value={`q${themeIndex + 1}_${index + 1}`}
                readOnly
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-600 cursor-not-allowed"
              />
              <span className="text-sm text-gray-500">
                Thème {themeIndex + 1}, Question {index + 1}
              </span>
            </div>
            <p className="mt-1 text-xs text-gray-500">
              ✨ L'ID est automatiquement généré selon la position
            </p>
          </div>

          {/* Question text */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Texte de la question *
            </label>
            <textarea
              value={question.text}
              onChange={(e) => handleChange('text', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              rows="2"
              placeholder="ex: Comment évaluez-vous le niveau de formalisation de votre vision stratégique?"
              required
            />
          </div>

          {/* Question description (tooltip/help) */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Description / Aide contextuelle
            </label>
            <textarea
              value={question.description || ''}
              onChange={(e) => handleChange('description', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              rows="3"
              placeholder="Texte d'aide affiché à l'utilisateur pour mieux comprendre la question..."
            />
            <p className="mt-1 text-xs text-gray-500">
              Ce texte apparaît comme info-bulle pour guider l'utilisateur
            </p>
          </div>

          {/* Question weight */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Poids (1-10) *
            </label>
            <input
              type="number"
              min="1"
              max="10"
              value={question.weight}
              onChange={(e) => handleChange('weight', parseInt(e.target.value))}
              className="w-32 px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              required
            />
            <p className="mt-1 text-xs text-gray-500">
              Importance de la question (1-10, score max = poids × 10)
            </p>
          </div>
        </div>

        {/* Delete button */}
        <div className="flex-shrink-0 pt-2">
          <button
            type="button"
            onClick={onDelete}
            className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            title="Supprimer la question"
          >
            <Trash2 className="w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Question number badge */}
      <div className="mt-3 flex items-center justify-between text-xs text-gray-500">
        <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded">
          Question #{index + 1}
        </span>
        <span>
          Score max: {question.weight * 10} points
        </span>
      </div>
    </div>
  )
}

export default QuestionEditor

